/** Normalize public web links, including standard YouTube watch links. */
export function normalizePanelUrl(input: string): string {
  const value = input.trim();
  if (!value) throw new Error('Enter a website or video URL.');
  const url = new URL(/^[a-z][a-z\d+.-]*:/i.test(value) ? value : `https://${value}`);
  if (url.protocol !== 'https:' && url.protocol !== 'http:') throw new Error('Use an http or https URL.');
  if (url.username || url.password) throw new Error('Use a URL without a username or password.');
  if (url.protocol === 'http:') url.protocol = 'https:';
  const host = url.hostname.replace(/^www\./, '');
  const id = host === 'youtu.be' ? url.pathname.slice(1) :
    (host === 'youtube.com' || host === 'm.youtube.com') ?
      (url.searchParams.get('v') || url.pathname.match(/^\/(?:shorts|embed)\/([^/]+)/)?.[1]) : null;
  if (id && /^[\w-]{11}$/.test(id)) return `https://www.youtube.com/embed/${id}`;
  return url.href;
}
